<template>
  <v-modal
    handle-click-bg
    full
    position="bottom"
    block-scroll
    animation="slide-up"
    v-model="showOrders"
    min-width="50rem"
  >
    <template v-slot:activator="{ on }">
      <transition name="slide-top">
        <box class="mb-1" clickable color="info" outline @click="on()" v-if="num > 0">
          <div class="dashboard-actions-item d-flex justify-stretch align-center">
            <div><span class="icon-attention text--xxx-large text-color-info"></span></div>
            <div class="ml-2 text--medium">
              <span>{{ $t('widgets.Dashboard.DashboardActions.requireAction') }}</span>
              <br>
              <span class="text-color-space text--small">{{ ordersCountTranslate }}</span>
            </div>
          </div>
        </box>
      </transition>
    </template>

    <template v-slot:header>
        {{ $t('widgets.Dashboard.DashboardActions.orders') }}
    </template>

    <div style="max-width: 78rem" class="mx-auto my-1">
<!--      <list-footer :total="!orders ? 0 : orders.totalElements" :loading="reFetchingLoc"></list-footer>-->
      <orders-list
        date-field="orderedAt"
        :orders="orders ? orders.content : []"
        :loading="loading"

        @accept="acceptOrder"
        @decline="e => openDeclinePartnerComment(e, false)"
        @revert="e => openDeclinePartnerComment(e, true)"
      ></orders-list>
      <list-footer :loading="fetchingMore || $apollo.queries.orders.loading" :total="!orders ? 0 : orders.totalElements"></list-footer>
    </div>

    <decline-partner-comment
      v-model="showDeclinePartnerComment"
      :comment="declinePartnerComment"

      @change="(e) => declinePartnerComment = e"
      @confirm="confirmChangeOrderStatus()"
      @cancel="showDeclinePartnerComment = false"
    ></decline-partner-comment>
  </v-modal>
</template>

<script>
import Box from '@/ui/slots/Box'
import vModal from '@/ui/modals/vModal'
import ListFooter from '@/ui/slots/List/ListFooter'

import OrdersList from '@/components/OrdersList'
import DeclinePartnerComment from '@/components/DeclinePartnerComment'

import { pluralize } from 'numeralize-ru'

import { SettlementsGQL, OrdersGQL } from '@/graphql/queries'

import { threeYearsAgo, now } from '@/utils'

import currContractId from '@/mixins/currContractId'
import screen from '@/mixins/screen'
import fetchMore from '@/mixins/fetchMore'
import { ChangeOrderStatusGQL } from '@/graphql/mutations'

const queryVars = {
  descending: true,
  orderedAtFrom: threeYearsAgo().toISOString(),
  orderedAtTo: now.toISOString(),
  sortBy: 'ORDERED_AT'
}

export default {
  components: {
    Box,
    vModal,
    ListFooter,

    OrdersList,
    DeclinePartnerComment
  },

  mixins: [currContractId, screen, fetchMore],

  data () {
    return {
      showOrders: false,
      size: 20,

      showDeclinePartnerComment: false,
      declinePartnerComment: null,
      isRevert: false,

      shouldLoading: false
    }
  },

  apollo: {
    settlements: {
      query: SettlementsGQL,
      variables () {
        return {
          params: {
            partnerContractId: this.currContractId
          }
        }
      },
      update: data => data.merchant.settlements,
      skip () {
        return !this.currContractId
      }
    },

    orders: {
      query: OrdersGQL,
      variables () {
        return {
          params: {
            ...queryVars,
            page: 0,
            size: this.size,
            status: 'PENDING',
            partnerContractId: +this.currContractId,
            canChangeStatus: true
          }
        }
      },
      update: data => data.merchant.orders,
      skip () { return !this.currContractId || !this.showOrders }
    }
  },

  methods: {
    showMore () {
      const params = {
        ...queryVars,
        page: 0,
        size: this.size,
        status: 'PENDING',
        partnerContractId: +this.currContractId
      }

      if (this.orders) {
        this.fetchMore({
          params,
          apolloQueryField: 'orders',
          rootField: 'merchant',
          currPage: this.orders.currentPage
        })
      }
    },

    acceptOrder ({ id }) {
      this.$apollo.mutate({
        mutation: ChangeOrderStatusGQL,
        variables: {
          params: {
            declinePartnerComment: null,
            id,
            partnerApproved: true
          }
        }
        // update: (store, { data: { changeOrderStatus } }) => {
        //   const params = {
        //     ...this.queryVars,
        //     ...this.paginationVars,
        //     status: this.activeFilter.value,
        //     typeAddEnum: this.sourceFilter.value,
        //     partnerContractId: +this.currContractId
        //   }
        //
        //   store.readQuery({
        //     query: OrdersGQL,
        //     variables: {
        //       params
        //     }
        //   })
        // }
      })
    },

    openDeclinePartnerComment ({ id }, isRevert) {
      this.declineOrderId = id
      this.isRevert = isRevert
      this.showDeclinePartnerComment = true
    },

    confirmChangeOrderStatus () {
      if (this.isRevert) {
        this.revertOrder()
      } else {
        this.declineOrder()
      }
    },

    async declineOrder () {
      try {
        await this.$apollo.mutate({
          mutation: ChangeOrderStatusGQL,
          variables: {
            params: {
              declinePartnerComment: this.declinePartnerComment,
              id: this.declineOrderId,
              partnerApproved: false
            }
          }
          // update: (store, { data: { changeOrderStatus } }) => {
          //   const params = {
          //     ...this.queryVars,
          //     ...this.paginationVars,
          //     status: this.activeFilter.value,
          //     typeAddEnum: this.sourceFilter.value,
          //     partnerContractId: +this.currContractId
          //   }
          //
          //   store.readQuery({
          //     query: OrdersGQL,
          //     variables: {
          //       params
          //     }
          //   })
          // }
        })
      } catch (e) {
        this.notifyGraphqlError(e)
      }

      this.showDeclinePartnerComment = false
    },

    async revertOrder () {
      try {
        await this.$apollo.mutate({
          mutation: ChangeOrderStatusGQL,
          variables: {
            params: {
              declinePartnerComment: this.declinePartnerComment,
              id: this.declineOrderId,
              partnerApproved: null
            }
          }
          // update: (store, { data: { changeOrderStatus } }) => {
          //   const params = {
          //     ...this.queryVars,
          //     ...this.paginationVars,
          //     status: this.activeFilter.value,
          //     typeAddEnum: this.sourceFilter.value,
          //     partnerContractId: +this.currContractId
          //   }
          //
          //   store.readQuery({
          //     query: OrdersGQL,
          //     variables: {
          //       params
          //     }
          //   })
          // }
        })
      } catch (e) {
        this.notifyGraphqlError(e)
      }

      this.showDeclinePartnerComment = false
    }
  },

  computed: {
    loading () {
      if (this.shouldLoading) {
        return this.shouldLoading
      }
      return this.$apollo.queries.orders && this.$apollo.queries.orders.loading && !this.fetchingMore
    },

    loadingMore () {
      return this.orders && this.$apollo.queries.orders && this.$apollo.queries.orders.loading && this.fetchingMore
    },

    num () {
      return this.computedSettlements.clientOrdersRequireAction
    },

    computedSettlements () {
      if (!this.settlements) {
        return {
          clientOrdersCheckCount: 0,
          clientOrdersPendingCount: 0,
          clientOrdersRequireAction: 0
        }
      }

      return this.settlements
    },

    ordersCountTranslate () {
      const num = this.num
      return pluralize(
        num,
        this.$i18n.t('widgets.Dashboard.DashboardActions.numOfOrders.one', { num }),
        this.$i18n.t('widgets.Dashboard.DashboardActions.numOfOrders.two', { num }),
        this.$i18n.t('widgets.Dashboard.DashboardActions.numOfOrders.five', { num })
      )
    }
  },

  watch: {
    showDeclinePartnerComment (val) {
      if (val === false) {
        this.declinePartnerComment = null
      }
    },
    showOrders (val) {
      if (val) {
        this.shouldLoading = true

        setTimeout(() => {
          this.shouldLoading = false
        }, 300)
      }
    }
  },

  mounted () {
    document.addEventListener('reachedBottom', this.showMore)
  },

  beforeDestroy () {
    document.removeEventListener('reachedBottom', this.showMore)
  }
}
</script>
